<template>
    <div>
        <div v-if="animalThumbnailAbsolutePath" class="mr-2">
            <img :src="animalThumbnailAbsolutePath" :width="size" :height="size" class="rounded-circle" alt=""/>
        </div>
        <div v-else class="mr-2">
            <img :src="cat" :width="size" :height="size" v-if="animalSpecies === 15 || animalSpecies === 20"  alt=""/>
            <img :src="dog" :width="size" :height="size" v-else  alt=""/>
        </div>
    </div>
</template>

<script>
    import dog from '../../../assets/img/dog.png'
    import cat from '../../../assets/img/cat.png'
    export default {
        name: "AnimalAvatar",
        props: {
            animalData: null,
            species: null,
            thumbnailAbsolutePath: null,
            size: { type: Number, default: 36 }
        },
        data() {
            return {
                dog,
                cat
            }
        },
        computed: {
            animalSpecies() {
                return this.animalData ? this.animalData['breed_object']['species'] : this.species
            },
            animalThumbnailAbsolutePath() {
                return this.animalData && this.animalData['avatar_object'] ? this.animalData['avatar_object']['absolute_url'] : this.thumbnailAbsolutePath
            }
        }
    }
</script>

<style scoped>

</style>